<template>
  <b-form-group
    v-bind="$props"
    class="mb-2"
    :description="labelStyle === 'Description' ? helpfulTip : ''"
  >
    <template v-slot:label>
      <slot name="label">
        {{ label }}
        <HelpfulTooltip :text="helpfulTip" />
      </slot>
    </template>

    <slot />
  </b-form-group>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import HelpfulTooltip from '@/components/builder/UI/HelpfulTooltip.vue'

const components = {
  HelpfulTooltip,
}

const props = {
  contentCols: [Boolean, Number, String],
  contentColsLg: [Boolean, Number, String],
  contentColsMd: [Boolean, Number, String],
  contentColsSm: [Boolean, Number, String],
  contentColsXl: [Boolean, Number, String],
  description: String,
  disabled: Boolean,
  feedbackAriaLive: String,
  id: String,
  invalidFeedback: String,
  label: String,
  labelAlign: String,
  labelAlignLg: String,
  labelAlignMd: String,
  labelAlignSm: String,
  labelAlignXl: String,
  labelClass: {
    type: [Array, Object, String],
    default: 'pb-1',
  },
  labelCols: [Boolean, Number, String],
  labelColsLg: [Boolean, Number, String],
  labelColsMd: [Boolean, Number, String],
  labelColsSm: [Boolean, Number, String],
  labelColsXl: [Boolean, Number, String],
  labelFor: String,
  labelSize: String,
  labelSrOnly: Boolean,
  state: Boolean,
  tooltip: Boolean,
  validFeedback: String,
  validated: Boolean,
  helpfulTip: {
    type: String,
    default: null,
  },
  labelStyle: {
    type: String,
    default: 'Tooltip',
    validator: (value: string) => {
      // The value must match one of these strings
      return ['Tooltip', 'Description'].indexOf(value) !== -1
    },
  },
}

@Component({ components })
export default class LabelledInput extends Vue.extend({ props }) {}

</script>
